import { StaticBaseDao } from '@/dao';
import { IntArray, FISDataCategory, PostResponse, FISDataRace } from '@/objects/generated';

export class FISDataEventDao extends StaticBaseDao {
    public static async GetCategories(EventID: number, uids: IntArray, detailed: boolean): Promise<FISDataCategory[]> {
        return this.BaseFetchArray(
            FISDataCategory,
            `FISDataEvent/GetCategories` +
                '?' +
                (EventID == undefined ? '' : `EventID=${EventID}`) +
                '&' +
                (detailed == undefined ? '' : `detailed=${detailed}`),
            'POST',
            uids,
        );
    }
    public static async SaveCategories(EventID: number, data: FISDataCategory[]): Promise<PostResponse | null> {
        return this.BaseFetch(
            PostResponse,
            `FISDataEvent/SaveCategories` + '?' + (EventID == undefined ? '' : `EventID=${EventID}`),
            'POST',
            data,
        );
    }
    public static async GetRaces(EventID: number, uids: IntArray, detailed: boolean): Promise<FISDataRace[]> {
        return this.BaseFetchArray(
            FISDataRace,
            `FISDataEvent/GetRaces` +
                '?' +
                (EventID == undefined ? '' : `EventID=${EventID}`) +
                '&' +
                (detailed == undefined ? '' : `detailed=${detailed}`),
            'POST',
            uids,
        );
    }
    public static async SaveRaces(EventID: number, data: FISDataRace[]): Promise<PostResponse | null> {
        return this.BaseFetch(
            PostResponse,
            `FISDataEvent/SaveRaces` + '?' + (EventID == undefined ? '' : `EventID=${EventID}`),
            'POST',
            data,
        );
    }
}
